import {TrendingWordsWrapper} from 'views/storyboard/charts/trending/TrendingWordsWrapper';

export default TrendingWordsWrapper;
